function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentPermata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 127,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 87.757375,50.465366 48.481222,0 9.2178984,50.465366 C 2.5856633,59.009151 0,66.438903 0,74.514409 0,86.855335 6.3090193,97.930643 17.60837,105.67709 L 48.468279,126.5618 79.341016,105.67709 C 90.653339,97.930643 96.949501,86.842679 96.949501,74.514409 96.962445,66.45156 94.376557,59.009151 87.757375,50.465366 Z M 42.185061,103.6265 v 7.4427 L 23.28389,98.411578 C 14.402157,92.563847 9.3859667,83.855533 9.3859667,74.995344 c 0,-4.582113 1.2928293,-9.012063 3.5552643,-13.138265 0.969636,2.68311 2.585687,5.379164 6.140951,9.341123 l 20.038933,21.833924 c 3.218984,3.632899 3.063946,5.84773 3.063946,10.594374 z M 27.31753,66.45156 c -5.016191,-5.379452 -5.972883,-8.379254 -5.972883,-11.543587 0,-3.012458 0.646415,-5.695856 4.524901,-10.607029 l 22.624618,-28.795571 22.62436,28.795571 c 3.723505,4.911173 4.525159,7.594571 4.525159,10.607029 0,3.164333 -0.969636,6.176791 -5.972854,11.543587 L 48.481222,89.551389 Z M 73.69147,98.411578 54.790328,111.0692 v -7.4427 c 0,-4.746644 -0.155326,-6.961475 3.07689,-10.60703 l 20.03876,-21.833924 c 3.555235,-3.949303 5.171487,-6.645357 6.141123,-9.341124 2.262292,4.113547 3.555236,8.543497 3.555236,13.138266 -0.01294,8.872845 -5.016162,17.568503 -13.910867,23.42889 z",
    fill: "white",
    id: "path24",
    style: {
      fill: "#0064ff",
      fillOpacity: 1,
      strokeWidth: 2.8764
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPermata);
export default __webpack_public_path__ + "static/media/payment_permata.4ea0c25b7f3f3b3de9ed8b0aa53722d8.svg";
export { ForwardRef as ReactComponent };